var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18403_21130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 0C11.7912 0 7.7497 1.39852 4.94793 4.19793C2.14852 6.9997 0.75 11.0412 0.75 16C0.75 20.9588 2.14852 25.0003 4.94793 27.8021C7.7497 30.6015 11.7912 32 16.75 32C21.7088 32 25.7503 30.6015 28.5521 27.8021C31.3515 25.0003 32.75 20.9588 32.75 16C32.75 11.0412 31.3515 6.9997 28.5521 4.19793C25.7503 1.39852 21.7088 0 16.75 0Z",
    fill: "#EBEDF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5187 12.4229C15.4033 12.2499 15.2303 12.1153 15.0381 12.0577C14.8458 11.9808 14.6343 11.9808 14.4421 12.0577C14.2498 12.1153 14.0768 12.2307 13.9422 12.4037C13.8077 12.5383 13.75 12.7498 13.75 12.942V18.8248C13.75 19.0939 13.8461 19.3438 14.0384 19.5169C14.2114 19.6899 14.4613 19.8052 14.7112 19.8052C14.9612 19.8052 15.2111 19.7091 15.3841 19.5169C15.5571 19.3438 15.6725 19.0939 15.6725 18.844V16.1333L17.8449 19.3823C17.9602 19.5553 18.1332 19.6899 18.3255 19.7476C18.5177 19.8244 18.7292 19.8244 18.9214 19.7476C19.1137 19.6899 19.2867 19.5745 19.4213 19.4015C19.5366 19.2285 19.6135 19.0362 19.6135 18.8248V12.9612C19.6135 12.7113 19.5174 12.4614 19.3252 12.2884C19.1521 12.1153 18.9022 12 18.6523 12C18.4024 12 18.1525 12.0961 17.9794 12.2884C17.8064 12.4614 17.6911 12.7113 17.6911 12.9612V15.6719L15.5187 12.4229ZM16.75 9C14.3288 9 12.6254 9.67697 11.5255 10.7755C10.427 11.8754 9.75 13.5788 9.75 16C9.75 18.4213 10.427 20.1247 11.5256 21.2246C12.6255 22.3231 14.3288 23 16.75 23C19.1712 23 20.8746 22.323 21.9745 21.2245C23.073 20.1246 23.75 18.4212 23.75 16C23.75 13.5788 23.0731 11.8755 21.9746 10.7756C20.8747 9.67701 19.1713 9 16.75 9ZM23.3887 22.6387C21.8127 24.2133 19.5393 25 16.75 25C13.9607 25 11.6873 24.2133 10.1113 22.6387C8.53667 21.0627 7.75 18.7893 7.75 16C7.75 13.2107 8.53667 10.9373 10.1113 9.36133C11.6873 7.78667 13.9607 7 16.75 7C19.5393 7 21.8127 7.78667 23.3887 9.36133C24.9633 10.9373 25.75 13.2107 25.75 16C25.75 18.7893 24.9633 21.0627 23.3887 22.6387Z",
    fill: "#181E26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18403_21130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new-icon.4b6183b0baeb2b7c0ac01599725dbe46.svg";
export { ForwardRef as ReactComponent };